import React from 'react';
import { connect } from 'react-redux';
import { toPlainObject } from 'lodash';
import { withRouter } from 'react-router-dom';

import { PATH } from '../../../constants/path';

import { isTokenExpired } from '../../../services/authentication/utils';

import { Logo } from '../../icons/Logo';
import HeadComponent from '../../HeadComponent';
import LocalizedNavLink from '../../router/LocalizedNavLink';
import LoggedOutComponent from '../../header/membernav/LoggedOutComponent';
import LogoutButtonComponent from '../../authentication/logout/LogoutButtonComponent';
import UpdatePasswordFormComponent from '../account/myprofile/UpdatePasswordFormComponent';

import './PasswordUpdatePage.scss';

export class PasswordUpdatePage extends React.Component {
    componentWillMount() {
        this.checkAuthentication(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.checkAuthentication(nextProps);
        }
    }

    componentDidUpdate(prevProps) {
        const { isAuthenticated, user } = this.props;

        if (prevProps.isAuthenticated !== isAuthenticated) {
            this.checkAuthentication(this.props);
        }
        if (!prevProps.user.passwordUpdated && user.passwordUpdated) {
            this.checkAuthentication(this.props);
        }
    }

    isMemberAuthenticated = () => !isTokenExpired(this.props.token) && this.props.isAuthenticated;

    checkAuthentication({ history, user }) {
        if (!this.isMemberAuthenticated() || user.passwordUpdated) {
            new Promise((resolve, reject) => {
                history.push(PATH.HOME_PATH);
                resolve();
            });
        }
    }

    render() {
        const { i18nPage, BRAND_NAME, LOG_OUT } = this.props;

        return (
            <div className="template template-primary flex-container-v">
                <div className="entete hideNav" id="entete">
                    <div className="flex-container-v">
                        <header className="tetedepage conteneur flex-container-h flex-center-alt passwd-update">
                            <LocalizedNavLink
                                to={PATH.HOME_PATH}
                                title={BRAND_NAME}
                                className="logo">
                                <Logo />
                            </LocalizedNavLink>
                            <div className="menu-membre flex-container-h flex-center-alt">
                                {this.isMemberAuthenticated() ? (
                                    <div className="flex-container-h flex-center-alt">
                                        <LogoutButtonComponent
                                            className="deconnexion hidden-mobonly"
                                            text={LOG_OUT}
                                            isText
                                        />
                                    </div>
                                ) : (
                                    <LoggedOutComponent />
                                )}
                            </div>
                        </header>
                    </div>
                </div>
                <main id="p-password-update" className="conteneur conteneur-mobile">
                    <HeadComponent
                        title={i18nPage.TITLE}
                        description={i18nPage.DESCRIPTION}
                        canonicalLink={PATH.UPDATE_PASSWORD_PATH}
                    />
                    <h1>{i18nPage.TITLE}</h1>

                    <div className="wrapper">
                        <p>{i18nPage.TEXT1}</p>
                        <p>{i18nPage.TEXT2}</p>

                        <UpdatePasswordFormComponent />
                    </div>
                </main>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const user = toPlainObject(state.account.user);

    return {
        i18nPage: state.i18n.page.PASSWORD_UPDATE,
        BRAND_NAME: state.i18n.common.BRAND_NAME,
        LOG_OUT: state.i18n.feature.header.MEMBER_NAV.LOG_OUT,
        token: state.authentication.token,
        isAuthenticated: state.authentication.isAuthenticated,
        user: user
    };
};

export default withRouter(connect(mapStateToProps, null)(PasswordUpdatePage));



// WEBPACK FOOTER //
// ./src/components/pages/password-update/PasswordUpdatePage.js